import { useRef, useEffect, ReactNode } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(ref: any, setShow: (show: boolean) => void) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: { target: any }) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setShow]);
}

/**
 * Component that alerts if you click outside of it
 */
const OutsideClickHandler: React.FC<{
  children?: ReactNode;
  showDiv: (state: boolean) => void;
  show: boolean;
  className?: string;
}> = ({ children, show, showDiv, className }) => {
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, showDiv);

  if (!show) {
    return null;
  }

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      ref={wrapperRef}
      className={className}
    >
      {children}
    </div>
  );
};

export default OutsideClickHandler;
